import config from '../../config';
import { numberMap } from '../../utils';

const METER_X = config.WIDTH - 40;
const METER_Y = config.HEIGHT - 60;

const METER_FILL_TOTAL = 100;

class PowerMeter {
  constructor (gameContext) {
    this.g = gameContext;
    let g = this.g;

    let meterBg = g.add.sprite(METER_X, METER_Y - 8, 'hero', 'white-meter-bg.png');
    meterBg.setOrigin(0.5, 1);

    // default meter
    let frames = g.anims.generateFrameNames('meter', {
      prefix: 'default/green-meter_',
      start: 0,
      end: 29,
      suffix: '.png',
      zeroPad: 2
    });
    let defaultMeter = g.add.sprite(METER_X, METER_Y - 6, 'meter');
    defaultMeter.setOrigin(0.5, 1);
    defaultMeter.setFrame(frames[0].frame);
    defaultMeter.frames = frames;
    defaultMeter.fillAmount = 0;
    defaultMeter.on('animationcomplete', () => {
      // meter.alpha = 0;
      this.setPower(100);
    });

    // almost full meter
    frames = g.anims.generateFrameNames('meter', {
      prefix: 'almost-full/blue-meter_',
      start: 0,
      end: 29,
      suffix: '.png',
      zeroPad: 2
    });
    let almostMeter = g.add.sprite(METER_X, METER_Y - 6, 'meter');
    almostMeter.setOrigin(0.5, 1);
    almostMeter.setFrame(frames[0].frame);
    almostMeter.frames = frames;
    almostMeter.alpha = 0;
    almostMeter.pulseTween = null;

    // drain meter
    frames = g.anims.generateFrameNames('meter', {
      prefix: 'drain/red-meter_',
      start: 0,
      end: 29,
      suffix: '.png',
      zeroPad: 2
    });
    let drainMeter = g.add.sprite(METER_X, METER_Y - 6, 'meter');
    drainMeter.setOrigin(0.5, 1);
    drainMeter.setFrame(frames[0].frame);
    drainMeter.frames = frames;
    drainMeter.alpha = 0;
    drainMeter.pulseTween = null;

    // special meter
    frames = g.anims.generateFrameNames('meter', {
      prefix: 'special/yellow-meter_',
      start: 0,
      end: 29,
      suffix: '.png',
      zeroPad: 2
    });
    let specialMeter = g.add.sprite(METER_X, METER_Y - 6, 'meter');
    specialMeter.setOrigin(0.5, 1);
    specialMeter.setFrame(frames[0].frame);
    specialMeter.frames = frames;
    specialMeter.alpha = 0;
    specialMeter.pulseTween = null;

    let meterCase = g.add.sprite(METER_X, METER_Y - 8, 'hero', 'meter-case.png');
    meterCase.setOrigin(0.5, 1);

    let face = g.add.sprite(METER_X, METER_Y - 8, 'hero', 'meter-icon.png');

    this.assets = { defaultMeter, almostMeter, drainMeter, specialMeter, face };

    // console.log('Constructor', this);
  }
  get isFilled () {
    let { defaultMeter } = this.assets;
    return defaultMeter.fillAmount >= METER_FILL_TOTAL;
  }
  fillAnimate () {
    let { defaultMeter } = this.assets;
    // specialMeter.alpha = 1;
    defaultMeter.play('default-meter-fill');
  }
  addPower (power) {
    let { defaultMeter } = this.assets;
    let fillAmount = defaultMeter.fillAmount + power;
    if (fillAmount > 100) {
      fillAmount = 100;
    } else if (fillAmount < 0) {
      fillAmount = 0;
    }
    defaultMeter.fillAmount = fillAmount;
    this.updateMeter();
  }
  drainPower (power) {
    let g = this.g;
    let { defaultMeter, drainMeter } = this.assets;
    let fillAmount = defaultMeter.fillAmount - power;
    if (fillAmount > 100) {
      fillAmount = 100;
    } else if (fillAmount < 0) {
      fillAmount = 0;
    }
    defaultMeter.fillAmount = fillAmount;
    drainMeter.pulseTween = g.tweens.add({
      targets: drainMeter,
      alpha: 1,
      yoyo: true,
      repeat: 10,
      duration: 45
    });
    this.updateMeter();
  }
  setPower (fill) {
    let g = this.g;
    let { defaultMeter } = this.assets;
    let fillAmount = Math.round(fill);
    // console.log(fillAmount);
    if (fillAmount > 100) {
      console.warn('Power meter overfilled!', fillAmount);
      fillAmount = 100;
    } else if (fillAmount < 0) {
      console.warn('Power meter over drained!', fillAmount);
      fillAmount = 0;
    }
    defaultMeter.fillAmount = fillAmount;
    // console.log(fillAmount);
    this.updateMeter();
  }
  updateMeter () {
    let g = this.g;
    let { defaultMeter, almostMeter, drainMeter, specialMeter } = this.assets;

    let fillAmount = defaultMeter.fillAmount;
    // console.log('fillAmout', defaultMeter.fillAmount);

    let frameIndex = ~~(numberMap(fillAmount, 0, METER_FILL_TOTAL, 0, defaultMeter.frames.length - 1));
    defaultMeter.setFrame(defaultMeter.frames[frameIndex].frame);

    almostMeter.setFrame(almostMeter.frames[frameIndex].frame);
    drainMeter.setFrame(drainMeter.frames[frameIndex].frame);
    specialMeter.setFrame(specialMeter.frames[frameIndex].frame);

    if (fillAmount === 100) {
      if (almostMeter.pulseTween !== null) {
        almostMeter.pulseTween.stop();
        almostMeter.pulseTween = null;
        almostMeter.alpha = 0;
      }
      specialMeter.pulseTween = g.tweens.add({
        targets: specialMeter,
        alpha: 1,
        yoyo: true,
        repeat: -1,
        duration: 125
      });
    } else if (fillAmount > 80 && specialMeter.pulseTween === null && almostMeter.pulseTween === null) {
      almostMeter.pulseTween = g.tweens.add({
        targets: almostMeter,
        alpha: 1,
        yoyo: true,
        repeat: -1,
        duration: 250
      });
    } else if (fillAmount < 80 && almostMeter.pulseTween !== null) {
      almostMeter.pulseTween.stop();
      almostMeter.pulseTween = null;
      almostMeter.alpha = 0;
    } else if (fillAmount === 0 && specialMeter.pulseTween !== null) {
      specialMeter.pulseTween.stop();
      specialMeter.pulseTween = null;
      specialMeter.alpha = 0;
    }
  }
}

export default PowerMeter;
